import * as React from "react";
import { QueryCache } from "./QueryCachePage";

type Props = {};

const QueryCachePage = (props: Props) => {
	return <QueryCache />;
};

export default QueryCachePage;
